module.exports = __webpack_public_path__ + "img/logo.c44c0616.png";